import { relations, sql } from "drizzle-orm";
import { jsonb, pgTable, text, timestamp, uuid, } from "drizzle-orm/pg-core";
import { dataRequestValidationTable } from "./dataRequestValidation.js";
import { dossier } from "./dossier.js";
import { hdnDossierTable } from "./hdn.js";
import { agency, appUser } from "./main.js";
import { workItem } from "./workItems.js";
export const DataRequestChannel = ["datakeeper", "hdn"];
export const dataRequestTable = pgTable("data_request", {
    content: jsonb("content"),
    dynamicLink: text("dynamic_link"),
    customerId: text("customer_id"),
    datakeeperTransactionId: text("datakeeper_transaction_id").unique(),
    hdnPersonId: text("hdn_person_id"),
    hdnDossierId: uuid("hdn_dossier_id")
        .references(() => hdnDossierTable.id, {
        onUpdate: "cascade",
        onDelete: "cascade",
    })
        .unique(),
    dataprovider: text("dataprovider")
        .notNull()
        .$type()
        .default("datakeeper"),
    channel: text("channel")
        .notNull()
        .default("datakeeper")
        .$type(),
    status: text("status")
        .default("pending")
        .notNull()
        .$type(),
    failureReason: text("failure_reason"),
    appliedAt: timestamp("applied_at", {
        withTimezone: true,
        mode: "string",
    }),
    appliedBy: uuid("applied_by").references(() => appUser.id, {
        onUpdate: "cascade",
        onDelete: "cascade",
    }),
    createdBy: uuid("created_by").references(() => appUser.id, {
        onUpdate: "cascade",
        onDelete: "cascade",
    }),
    parentDataRequestId: uuid("parent_data_request_id").references(() => dataRequestTable.id, {
        onUpdate: "cascade",
        onDelete: "cascade",
    }),
    dossierId: uuid("dossier_id")
        .notNull()
        .references(() => dossier.id, {
        onUpdate: "cascade",
        onDelete: "cascade",
    }),
    agencyId: uuid("agency_id")
        .notNull()
        .references(() => agency.id, { onUpdate: "cascade", onDelete: "cascade" }),
    id: uuid("id")
        .default(sql `uuid_generate_v4()`)
        .primaryKey()
        .notNull(),
    updatedAt: timestamp("updated_at", {
        withTimezone: true,
        mode: "string",
    })
        .defaultNow()
        .notNull(),
    createdAt: timestamp("created_at", {
        withTimezone: true,
        mode: "string",
    })
        .defaultNow()
        .notNull(),
});
export const dataRequestRelations = relations(dataRequestTable, ({ one, many }) => ({
    dossier: one(dossier, {
        fields: [dataRequestTable.dossierId],
        references: [dossier.id],
    }),
    agency: one(agency, {
        fields: [dataRequestTable.agencyId],
        references: [agency.id],
    }),
    updates: many(dataRequestUpdateTable),
    tokens: many(dataRequestTokenTable),
    validations: many(dataRequestValidationTable),
    workItems: many(workItem),
    parent: one(dataRequestTable, {
        fields: [dataRequestTable.parentDataRequestId],
        references: [dataRequestTable.id],
    }),
    children: many(dataRequestTable),
}));
export const dataRequestUpdateTable = pgTable("data_request_update", {
    diff: jsonb("diff").$type(),
    dataRequestId: uuid("data_request_id")
        .references(() => dataRequestTable.id, {
        onUpdate: "cascade",
        onDelete: "cascade",
    })
        .notNull(),
    dossierId: uuid("dossier_id")
        .notNull()
        .references(() => dossier.id, {
        onUpdate: "cascade",
        onDelete: "cascade",
    }),
    agencyId: uuid("agency_id")
        .notNull()
        .references(() => agency.id, {
        onUpdate: "cascade",
        onDelete: "cascade",
    }),
    id: uuid("id")
        .default(sql `uuid_generate_v4()`)
        .primaryKey()
        .notNull(),
    createdAt: timestamp("created_at", {
        withTimezone: true,
        mode: "string",
    })
        .defaultNow()
        .notNull(),
});
export const dataRequestUpdateRelations = relations(dataRequestUpdateTable, ({ one }) => ({
    dataRequest: one(dataRequestTable, {
        fields: [dataRequestUpdateTable.dataRequestId],
        references: [dataRequestTable.id],
    }),
    dossier: one(dossier, {
        fields: [dataRequestUpdateTable.dossierId],
        references: [dossier.id],
    }),
    agency: one(agency, {
        fields: [dataRequestUpdateTable.agencyId],
        references: [agency.id],
    }),
}));
export const dataRequestTokenTable = pgTable("data_request_token", {
    dataRequestId: uuid("data_request_id")
        .references(() => dataRequestTable.id, {
        onUpdate: "cascade",
        onDelete: "cascade",
    })
        .notNull(),
    tokenHash: text("token_hash").notNull(),
    purpose: text("purpose")
        .notNull()
        .$type()
        .default("datakeeper_auth"),
    id: uuid("id")
        .default(sql `uuid_generate_v4()`)
        .primaryKey()
        .notNull(),
    createdAt: timestamp("created_at", {
        withTimezone: true,
        mode: "string",
    })
        .defaultNow()
        .notNull(),
});
export const dataRequestTokenRelations = relations(dataRequestTokenTable, ({ one }) => ({
    dataRequest: one(dataRequestTable, {
        fields: [dataRequestTokenTable.dataRequestId],
        references: [dataRequestTable.id],
    }),
}));
